export default __webpack_public_path__ + "static/media/Dashboard.5165b725.svg";